<div class="container-fluid row_banner pb-5">
  <app-header></app-header>

  <div class="container about-us-container">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12">
        <div class="about-us-text">
          <div class="about-tag marb">
            <div class="about-us-tag">
              <span class="about-us-tag-f">ABOUT US</span>
            </div>
          </div>
          <h1 class="about-titlee marb">
            GrammarIn <span class="greenF">Vision</span>
          </h1>
          <p class="about-detail psmal">
            GrammarIn is an AI-powered tool that helps users identify and
            rectify grammatical mistakes from text in different languages. Our
            primary focus is on empowering people to write confidently.
            GrammarIn aims to make people invest their valuable time and effort
            in what to write instead of how to write. Using Artificial
            Intelligence and Natural Language Processing algorithms, Grammarin
            ensures your content is flawless and uplifts its quality.
          </p>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 text-center editor matop">
        <img
          src="../../assets/images/about-us/about main.png"
          alt="about-us"
          height="503px"
          width="509px"
          class="about-img"
        />
      </div>
    </div>
  </div>
</div>

<section class="about-fundamental">
  <div class="container">
    <div class="about-fundamental-text">
      <h2 class="about-heading2 text-center">
        The Fundamental Principles <span class="greenF"> We Uphold </span>
      </h2>
      <p class="about-detail2 text-center psmal">
        Our team's ultimate goal is to boost the efforts of people involved in
        written communication with GrammarIn. We
        <br class="d-md-block d-none" />
        ensure you polish your writing to convey your message to readers
        precisely and engagingly.
      </p>
    </div>

    <div class="row">
      <div class="col-lg-4 mb20">
        <div class="about-fundamental-tab">
          <div class="about-fundamental-tab-img">
            <img
              src="../../assets/images/about-us/Rectify Writing Mistakes.png"
              alt="rectify writing mistakes"
              height="260px"
              width="392px"
              class=""
            />
          </div>
          <h3>Rectify Writing Mistakes</h3>
          <!-- <p class="psmal">
            GrammarIn suggests possible rectifications to users for resolving
            their writing mistakes. Our platform doesn’t just leave you to the
            detection of grammar errors; it also lends its hands to help you
            correct them.
          </p> -->
          <p class="psmal">
            GrammarIn suggests possible rectifications to users for resolving
            their writing mistakes. Our <a  href="/grammar-checker"
            class="aTag" >grammar checker  </a>  doesn’t just leave you
            to the detection of grammar errors; it also lends its hands to help
            you correct them. You can also <a  href="/plagiarism-checker"
            class="aTag"> check plagiarism </a> in a matter of
            seconds using our platform.
          </p>
        </div>
      </div>
      <div class="col-lg-4 mb20">
        <div class="about-fundamental-tab">
          <div class="about-fundamental-tab-img">
            <img
              src="../../assets/images/about-us/Communicate Better in Your Native Tone.png"
              alt="communicate better"
              height="260px"
              width="392px"
            />
          </div>
          <h3>Communicate Better in Your Native Tone</h3>
          <p>
            GrammarIn supports 20+ languages to help you communicate better in
            your native tone. The suggestions are tailoring your communication
            to reflect your natural and authentic way of expressing yourself in
            your native language or dialect. You can use words and phrases that
            feel genuine to you.
          </p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="about-fundamental-tab">
          <div class="about-fundamental-tab-img">
            <img
              src="../../assets/images/about-us/Increase the Pace of Writing.png"
              alt="increase the Pace of Writing"
              height="260px"
              width="392px"
            />
          </div>
          <h3>Increase the Pace of Writing</h3>
          <p class="psmal">
            <a
              href="https://www.grammarin.com"
              [routerLink]="['/']"
              class="aTag"
            >
              GrammarIn
            </a>
            assists writers in improving their writing efficiency. With its
            super-fast algorithms, you can increase your writing pace, as you
            won’t be required to proofread text independently.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="beneficiaries">
  <div class="container">
    <div class="beneficiaries-text p-4">
      <h2 class="about-heading2">
        Beneficiaries of Our <span class="greenF">AI-Based Tools</span>
      </h2>
    </div>
    <div class="row justify-content-center mbl-row">
      <div class="col-lg-2 col-md-2 col-4 img-name">
        <img
          src="../../assets/images/about-us/image1.svg"
          alt="Webmasters"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <p class="mt-3">Webmasters</p>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name">
        <img
          src="../../assets/images/about-us/image2.svg"
          alt="Bloggers"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <p class="mt-3">Bloggers</p>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name">
        <img
          src="../../assets/images/about-us/image3.svg"
          alt="Proofreaders"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <p class="mt-3">Proofreaders</p>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name">
        <img
          src="../../assets/images/about-us/image4.svg"
          alt="Marketing Managers"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
          "
        >
          <p class="mt-3">Marketing Managers</p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name">
        <img
          src="../../assets/images/about-us/image5.svg"
          alt="Content Editors"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
          "
        >
          <p class="mt-3">Content Editors</p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name">
        <img
          src="../../assets/images/about-us/image6.svg"
          alt="Freelancers"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <p class="mt-3">Freelancers</p>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name mt-md-5">
        <img
          src="../../assets/images/about-us/image7.svg"
          alt="Teachers"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <p class="mt-3">Teachers</p>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name mt-md-5">
        <img
          src="../../assets/images/about-us/image8.svg"
          alt="Students"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <p class="mt-3">Students</p>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name mt-md-5">
        <img
          src="../../assets/images/about-us/image9.svg"
          alt="Professionals"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <p class="mt-3">Professionals</p>
      </div>
      <div class="col-lg-2 col-md-2 col-4 img-name mt-md-5">
        <img
          src="../../assets/images/about-us/image10.svg"
          alt="Researchers"
          height="140px"
          width="140px"
          class="beneficiaries-img"
        />
        <p class="mt-3">Researchers</p>
      </div>
    </div>
  </div>
</section>

<section class="number-metter">
  <div class="container">
    <div class="number-metter-cards mt-5">
      <h2 class="number-metter-heading text-center mt-5 mb-md-4">
        Numbers That <span class="greenF"> Matter! </span>
      </h2>
      <div class="row p-md-4 p-2">
        <div
          class="col-lg-4 col-md-4 col-12"
          *ngFor="let tool of helpingToolsData"
        >
          <div class="card">
            <div class="card_text ms-lg-5 ms-3">
              <span>{{ tool.value }}</span>
              <p>{{ tool.label }}</p>
            </div>
            <div class="number-metter-card me-lg-3 mt-md-4">
              <app-icons-free-tools
                [name]="tool.icon"
                class="number-metter-img"
              ></app-icons-free-tools>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="reach">
  <div class="container">
    <div class="row">
      <div
        class="col-lg-12 col-md-12 col-md-12"
        style="
          justify-content: center;
          text-align: center;
          justify-items: center;
        "
        class="reach_text"
      >
        <h2 class="about-heading2">
          Reach <span class="greenF">Out to Us!</span>
        </h2>
        <p class="mt-4">
          Grammarin’s customer support team is readily available to assist you.
          If you have any questions regarding our service
          <br class="d-md-block d-none" />
          or suggestions for improvement, feel free to contact
         <a href="mailto:support@grammarin.com" style="text-decoration: none;color: black;"> support&#64;grammarin.com</a>
        </p>
      </div>
    </div>
  </div>
</section>
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  title="Go to top"
>
  <svg
    id="i-chevron-top"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="15"
    height="32"
    fill="none"
    stroke="currentcolor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="3"
  >
    <path d="M30 20 L16 8 2 20" />
  </svg>
</a>

<app-footer></app-footer>
